var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell"},[_c('input',{ref:"timeCell",class:{
      _last: _vm.isLast,
      _new: _vm.status === _vm.statuses.NEW,
      _disabled: _vm.disabled
    },attrs:{"type":"text","placeholder":"__h __m"},domProps:{"value":_vm.formattedValue},on:{"change":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }